import { render, staticRenderFns } from "./GroupReservationStatus.vue?vue&type=template&id=567c1244&"
import script from "./GroupReservationStatus.vue?vue&type=script&lang=js&"
export * from "./GroupReservationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports